export const CALC_OPS = ['+', '-', '*', '/'] as const;
export type CalcOp = (typeof CALC_OPS)[number];

export function isCalcOp(value: string): value is CalcOp {
  return (CALC_OPS as readonly string[]).includes(value);
}

export function applyCalc(inn: number, op: string | undefined, rhs: number | undefined): number {
  const n = Number(rhs);
  const value = Number.isFinite(n) ? n : 0;
  if (op === '+') {
    return inn + value;
  }
  if (op === '-') {
    return inn - value;
  }
  if (op === '/') {
    if (value === 0) {
      throw new Error('division by zero');
    }
    return inn / value;
  }
  return inn * value;
}

export function calcCaption(op?: string, rhs?: number): string {
  const symbol = op === '+' ? '+' : op === '-' ? '−' : op === '/' ? '÷' : '×';
  if (rhs == null || !Number.isFinite(rhs)) {
    return symbol;
  }
  return `${symbol} ${rhs}`;
}
